module.exports = require('./helpers/bundle-url').getBundleURL('ba7Qm') + "logo.c51670a8.svg";